import { countries } from "../constants";
import {
  ISelectGroupedItemsProps,
  ISwAppSupportedCountry,
} from "../interfaces-and-types";

export const filterSupportedCountriesFromList = (
  supportedCountries: ISwAppSupportedCountry[]
): ISelectGroupedItemsProps[] => {
  if (supportedCountries == null || supportedCountries.length === 0) return [];

  return countries
    .filter((cgroup) =>
      cgroup.options.find((ctry) =>
        supportedCountries.find((c) => c.country_code === ctry.value)
      )
    )
    .map((cgroup) => ({
      groupLabel: cgroup.groupLabel,
      options: cgroup.options.filter((ctry) =>
        supportedCountries.find((c) => c.country_code === ctry.value)
      ),
    }));
};

export const getCountryNameFromCode = (countryCode: string): string | null =>
  countries
    .find(
      (grp) =>
        grp.options.find((ctry) => ctry.value === countryCode) !== undefined
    )
    ?.options.find((ctry) => ctry.value === countryCode)?.text as string;
